import { render } from "./UserUpdateComponent.vue?vue&type=template&id=408371c6"
import script from "./UserUpdateComponent.vue?vue&type=script&lang=js"
export * from "./UserUpdateComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__